export enum Category {
    Rider = "Rider",
    Horse = "Horse",
    Caballus="Caballus"
}
